import React from 'react';
import styled from 'styled-components';

import { viewerZIndices } from '../../../viewer/viewer-z-indices';
import { useFeatureFlag } from '../../hooks/use-feature-flag';
import { Icon } from '../icon/icon';

const SkyViewSpinner = () => {
  // The timeline bar's notch hangs from the top edge, over where the spinner would be
  const timelineBarEnabled = useFeatureFlag('SK-7562-timeline-bar');

  return (
    <Container $belowTimelineBar={timelineBarEnabled} data-testid="skyview-spinner">
      <Icon icon="spinner" spin={true} />
    </Container>
  );
};

const Container = styled.div<{ $belowTimelineBar: boolean }>`
  position: absolute;
  top: ${(props) => (props.$belowTimelineBar ? 48 : 12)}px;
  left: 50%;
  transform: translateX(-50%);
  z-index: ${viewerZIndices.menu};
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 6px 8px;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 16px;
  pointer-events: none;
`;

export { SkyViewSpinner };
